import React from 'react';

export default function MemoPreparationReview({ fileName, preparation, selectedMaximum, selectionConfirmed, onConfirmSelection, onConfirmTotal, onRetry, busy }) {
  if (!preparation) return null;
  if (preparation.loading) return <p role="status">Checking memo: {fileName}...</p>;
  const data = preparation.data;
  const review = preparation.review;
  const validation = data?.memoValidation;
  const needsConfirmation = validation?.status === 'needs_confirmation';
  const mismatch = data && Number(selectedMaximum) > 0 && Math.abs(Number(selectedMaximum) - Number(data.totalMarks)) > .001;
  const questions = data?.questions || review?.questions || [];
  const evidence = validation?.totalEvidence || review?.totalEvidence || [];
  const total = data?.totalMarks;
  return (
    <section className="memo-preparation-review" aria-label="Memo preparation">
      <strong>{review ? 'Memo needs review' : needsConfirmation ? 'Confirm memo total' : 'Memo checked'}: {fileName}</strong>
      {review && <p role="alert">{review.message}</p>}
      {data && <p>{questions.length} scored question{questions.length === 1 ? '' : 's'} detected, totalling {total} marks.</p>}
      {needsConfirmation && <p>No printed grand total was found. Check the extracted allocations against your memo, then confirm their total.</p>}
      {validation?.status === 'teacher_confirmed' && <p>You confirmed the question allocations and total of {total} marks.</p>}
      {mismatch && <div role="alert">
        <p>The memo is /{total}; the selected assessment section is /{selectedMaximum}. Check your selection in step 1. A whole paper may span several assessment sections.</p>
        <label><input type="checkbox" checked={Boolean(selectionConfirmed)} disabled={busy}
          onChange={event => onConfirmSelection(event.target.checked)} /> I have checked that this memo belongs to the selected assessment.</label>
      </div>}
      {(questions.length > 0 || evidence.length > 0) && <details open={Boolean(review || needsConfirmation)}>
        <summary>Detected allocations and total evidence</summary>
        {questions.length > 0 && <div className="memo-allocation-table"><table>
          <thead><tr><th>Question</th><th>Detected marks</th><th>Memo allocation</th></tr></thead>
          <tbody>{questions.map((question, index) => <tr key={`${question.questionNumber}-${index}`}>
            <td>{question.questionNumber}</td><td>{question.maxMarks ?? 'Unconfirmed'}</td><td>{question.markText || 'Not recorded'}</td>
          </tr>)}</tbody>
        </table></div>}
        {review && <p>These are extracted allocations awaiting validation; headings or duplicate rows may still need correction.</p>}
        {evidence.map((item, index) => <p key={index}>Page {item.page}: {item.text}</p>)}
        {!evidence.length && (data?.printedTotalText || review?.printedTotalText) && <p>Extracted total line: {data?.printedTotalText || review?.printedTotalText}</p>}
      </details>}
      {needsConfirmation && <button type="button" disabled={busy} onClick={onConfirmTotal}>Confirm allocations and total of {total} marks</button>}
      {review && <>
        <p>Your learner scripts and assessment selection are retained. Check the allocations above, replace an incorrect or incomplete memo, or retry the current memo. Conflicting allocations must be resolved before marking.</p>
        <button type="button" disabled={busy} onClick={onRetry}>Retry current memo</button>
      </>}
    </section>
  );
}
